function num(el, name, fallback = 0) {
  const v = parseInt(el.getAttribute(name), 10);
  return isNaN(v) ? fallback : v;
}

function initCategoryCarousel(carousel) {
  const perLg  = num(carousel, 'data-large-desktop-categories-per-row', 5);
  const perD   = num(carousel, 'data-desktop-categories-per-row', 4);
  const perLap = num(carousel, 'data-laptop-categories-per-row', 4);
  const perTab = num(carousel, 'data-tablet-categories-per-row', 3);
  const perMob = num(carousel, 'data-mobile-categories-per-row', 1);

  const gapLg  = num(carousel, 'data-large-desktop-categories-gap', 70);
  const gapD   = num(carousel, 'data-desktop-categories-gap', 70);
  const gapLap = num(carousel, 'data-laptop-categories-gap', 40);
  const gapTab = num(carousel, 'data-tablet-categories-gap', 40);
  const gapMob = num(carousel, 'data-mobile-categories-gap', 40);

  const splide = new Splide(carousel, {
    type: 'slide',
    perPage: perLg,
    perMove: 1,
    arrows: false,
    pagination: true,
    rewind: false,
    gap: `${gapLg}px`,
    breakpoints: {
      1798: { perPage: perD,   gap: `${gapD}px`   },
      1499: { perPage: perLap, gap: `${gapLap}px` },
      991:  { perPage: perTab, gap: `${gapTab}px` },
      767:  { perPage: perMob, gap: `${gapMob}px` },
    },
  });

  splide.mount();
  carousel.splideInstance = splide;
}

function mountCarousels() {
  document.querySelectorAll('.js-home-modern-categories-carousel').forEach((carousel) => {
    if (carousel.splideInstance) {
      carousel.splideInstance.destroy();
    }
    initCategoryCarousel(carousel);
  });
}

document.addEventListener('DOMContentLoaded', mountCarousels);

if (window.Shopify && Shopify.designMode) {
  setTimeout(function () {
    mountCarousels();
  }, 200);
  
  const events = [
    'shopify:section:load',
    'shopify:section:select',
    'shopify:block:select',
    'shopify:block:deselect',
    'shopify:section:unload'
  ];

  events.forEach(eventName => {
    document.addEventListener(eventName, () => {
      setTimeout(mountCarousels, 50);
    });
  });
}